module.exports = __webpack_public_path__ + "img/appbar_qrcode.1e03ee81.svg";